import { ReactNode } from "react";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import classNames from "classnames";
import { useStyles } from "./styles";

type IconProps = {
  href?: string | null;
  label: string;
  children: ReactNode;
};

const ProfileLink = ({ href, label, children }: IconProps) => {
  const isEnabled = href && href.length > 0;
  const classes = useStyles({ active: isEnabled });

  return (
    <Tooltip title={label} arrow>
      <Container fullWidth={false}>
        <Button<"a">
          variant="ghost"
          color="dark"
          data-testid={label}
          disabled={!isEnabled}
          target="_blank"
          rel="noreferrer"
          href={
            href && !href.startsWith("http") ? `https://${href}` : href || ""
          }
          isExternal
          className={classNames(classes.profileIcon, {
            active: isEnabled,
          })}
        >
          {children}
        </Button>
      </Container>
    </Tooltip>
  );
};

export default ProfileLink;
